import { useState, useEffect, useLayoutEffect } from 'react';
import styles from '../styles/body.module.scss'
import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';



export default function Success({siteId, siteName, firstName, lastName, signIn, signOut, setUserId}) {
  const navigate = useNavigate();

  useEffect(() => {
    const wasRefreshed = sessionStorage.getItem("wasRefreshed") === "true";
    const lastPathname = sessionStorage.getItem("lastPathname");
    const currentPathname = window.location.pathname;
    const storedId = localStorage.getItem("site_id");

    if (wasRefreshed && lastPathname === currentPathname && storedId) {
      sessionStorage.removeItem("wasRefreshed"); // Clean up the flag
      sessionStorage.removeItem("lastPathname");
      sessionStorage.removeItem("page");
      if(siteName == "" || siteName == null){
        navigate(`/site/${storedId}`, { replace: true });
      }
      
    }
  }, [navigate]);



  const [action, setAction] = useState('');

  useEffect(() => {
    const handlePopState = () => {
      if (siteId) {
        navigate(`/site/${siteId}`);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [siteId, navigate]);

  

  useLayoutEffect(() => {
    if(signIn == true){
        setAction("signed in to");
    }
    else if(signOut == true){
        setAction("signed out of");
    }
  }, [signIn, signOut]);



  return (

    <>
      <Box className={styles.successHeader} >
        <h1>Thank you, {firstName} {lastName}</h1>
        </Box>
        <Box className={styles.header} >
        <div className={styles.successIcon}> 
        {<CheckCircleOutlineIcon fontSize="inherit"/>}
        </div>
        <h4 className={styles.successText}>You have now {action} {siteName}</h4>
        </Box>
        <Box className={styles.questionH1} >
            <p className={styles.closeTab}>
            You can now close this page
          </p>
      </Box>



    </>
  );
}

